
import { throwError as observableThrowError, Observable, EMPTY } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, retry, map, } from 'rxjs/operators';
import { DnDialogService } from '../_modules/dn-dialog/dn-dialog.service';
import { StorageService } from '../storageprovider';
import { CookieService } from 'ngx-cookie-service';
import { objectToQueryString, Utility } from './utility';
// import { AppStore } from '../app.store';
// import { UsersState } from '../app.reducer';
// import { Store } from 'redux';
import { Router } from '@angular/router';
// import * as userActions from '../_model/user/user.actions';
import { Md5 } from 'ts-md5/dist/md5';
import { environment } from '../../environments/environment';
// import * as configActions from '../_model/config/config.actions';

@Injectable({
    providedIn: "root"
})
export class HttpClientHelper {

    private static privateKey = [
        "v" + "er" + "sion001",
        "v" + "er" + "s1on001",
        "v" + "er" + "s1on00i",
        "b" + "er" + "sion001",
        "v" + "cr" + "sion001",
        "v" + "er" + "si0n001",
        "v" + "er" + "sio_001",
        "v" + "er" + "sion0o1",
    ];
    private static publicKey = "";
    private static publicKeyInedx = 0;
    private unhandledApis = [
    ];

    constructor(
        private _dnDialogService: DnDialogService,
        private _httpClient: HttpClient,
        private _storage: StorageService,
        private _cookieService: CookieService,
        private _router: Router,
        private _utility: Utility
    ) {


        if (HttpClientHelper.publicKey == "") {
            let pConfig = window["pConfig"];
            if (!!pConfig) {
                HttpClientHelper.publicKey = pConfig.publicKey;
                HttpClientHelper.publicKeyInedx = 0;
                if (pConfig.privateKey) {
                    HttpClientHelper.privateKey = [pConfig.privateKey];
                }
            }
            else {
                var dateInedx = new Date().getTime();
                HttpClientHelper.publicKey = dateInedx + "";
                HttpClientHelper.publicKeyInedx = dateInedx
            }
        }

        var token = this._storage.GetSessionData("__t");
        if (token) {
            this.token = JSON.parse(token);

        }


    }


    public token: any = {};

    getAsync(url) {
        this._httpClient.get(url)
            .pipe(catchError((err) => { return observableThrowError(err) }))
            .subscribe();
    }
    getAsyncSubs(url) {
        return this._httpClient.get(url)
            .pipe(catchError((err) => { return observableThrowError(err) }))
    }

    public static JSONtoQueryString(json, isRaw = false) {
        var str = [];
        for (var p in json)
            if (json.hasOwnProperty(p)) {
                if (typeof (json[p]) === 'object') {
                    str = str.concat(objectToQueryString(json[p], p))
                } else {
                    if (json[p] !== undefined) {
                        str.push(!isRaw ? encodeURIComponent(p) + "=" + encodeURIComponent(json[p]) : `${p}=${json[p]}`);
                    }
                }
            }
        return str.join("&");
    }
    private logout() {
        var token = this._storage.GetSessionData("token")
        this._storage.RemoveSessionData("token");
        this._cookieService.delete('autologin', '/', this._utility.GetHost("", true));
        if (!!window['DN_Logout']) {
            window['DN_Logout'](token);
        }
        // this.store.dispatch({ type: userActions.LOGOUT, user: null });
        if (environment.app) {
            window["UserLogout"]();
        }
    }

    public invokeCert(cert) {
        HttpClientHelper.publicKeyInedx = 0;
        HttpClientHelper.publicKey = cert.publicKey;
        HttpClientHelper.privateKey = cert.privateKey;
    }

    /*
    ** 根据URL获取query的字符串，保证是原始格式
    */
    private get_query(url) {

        var result = "";
        if (url.indexOf('?') > -1) {
            var qs = url.substring(url.indexOf('?') + 1).split('&');
            if (qs.length > 0)
                for (var i = 0; i < qs.length; i++) {
                    qs[i] = qs[i].split('=');
                    result += qs[i][0]
                    for (var j = 1; j < qs[i].length; ++j) {
                        result += "=" + decodeURIComponent(qs[i][j])
                            .split("+").join(" ")
                    }
                    result += "&";
                }
        }
        if (result != "") {
            result = result.substring(0, result.length - 1);
        }
        return result;
    }
    private getPrivateKey() {
        return HttpClientHelper.privateKey[(HttpClientHelper.publicKeyInedx % HttpClientHelper.privateKey.length)];
    }

    /*
    ** 签名URL
    */
    public uriSignature(url, isForm = false, injectQuery = null): string {

        if (!!url) {
            var query = (injectQuery ?? this.get_query(url)) || "";
            var hasValue = true;
            if (query.indexOf('pub=') == -1 && query.indexOf('vv=') == -1) {
                if (!query) {
                    hasValue = false;
                }
                query = query.toLowerCase();
                query = HttpClientHelper.publicKey + "&" + query + "&" + this.getPrivateKey();
                //console.log(obj,query)
                if (isForm) {
                    url = url.substring(1);
                    return url + (hasValue ? "&" : "") + "vv=" + Md5.hashStr(query) + "&pub=" + HttpClientHelper.publicKey;
                }
                else {
                    return url + (hasValue ? "&" : "?") + "vv=" + Md5.hashStr(query) + "&pub=" + HttpClientHelper.publicKey;
                }
            }


        }
        return url;

    }

    /*
    ** 全局的错误信息处理
    */
    globalHandler(ret) {
        var result = true;
        // console.log(ret);
        switch (ret.code) {
            case 1:/// 显示消息
                this._dnDialogService.open('message-dialog',{ message: ret.msg });
                result = false;
                break;
            case 2: ///用户信息遭到篡改 显示消息
                // this._messageDialogService.setState({ message: "用户信息错误，请重新登录。" });
                this._dnDialogService.open('message-dialog',{ message: "用户信息错误，请重新登录。" });
                this.logout();

                result = false;
                break;
            case 3:///
                ///console.log("多地登录");
                // this._messageDialogService.setState({
                //     message: "检测到您的帐户在别处登录，帐户可能已被盗用，建议立即修改密码。"
                // });
                this._dnDialogService.open('message-dialog',{
                    message: "检测到您的帐户在别处登录，帐户可能已被盗用，建议立即修改密码。"
                });

                this.logout();
                this._router.navigate(['/']);
                result = false;
                break;
            case 4:
                //console.log("用户过期，需要重新验证");
                this._dnDialogService.open('prevent-dialog');
                result = false;
                break;
            case 5:
                this._router.navigateByUrl('/challenge?return=' + encodeURIComponent(this._router.url) + '&triggerindex=' + (ret.msg || 0))
                //HttpClientHelper.publicKey = new Date().getTime(); /// 这里重置一下
                result = false;
                break;

        }
        return result;
    }

    /*
    ** 返回
    ** url：添加用户信息的URL
    ** query：query参数
    */
    public appendUserInfo(url) {
        var query = this.get_query(url);
        if (this.token && this.token.uid > 0) {
            var obj = this._utility.parseJSON(query);
            var result = [];
            var rawQuery = [];
            obj = Object.assign({}, obj, this.token);
            url = url.split("?")[0];
            Object.keys(obj).forEach(p => {
                result.push(p + "=" + encodeURIComponent(obj[p]));
                rawQuery.push(p + "=" + obj[p]);
            })
            query = rawQuery.join("&");
            url = url + "?" + result.join("&");
        }
        return {
            url: url,
            query: query
        };
    }

    /*
    ** 允许后端缓存
    */
    getWithCache(url)
    {
        return this.get(url +"&cacheable=1",false,true,false);
    }
    /*
    ** 传递URl
    ** 是否使用自定义方法
    */
    get(url, custom = false, rawUrl = false,withSign = true) {
        let query = null;
        if (!rawUrl) {
            let append = this.appendUserInfo(url);
            url = append.url;
            query = append.query;
        }
        return this._httpClient.get(withSign?this.uriSignature(url, false, query):url,{
            withCredentials:true ////cdn防御
        })
            .pipe(map((res: any) => {
                if (!custom) {
                    const r = typeof (res) === 'string' ? JSON.parse(res).data : res.data;
                    if (!this.globalHandler(r)) {
                        return { code: 400 + r.code };
                    }
                    return r.info;
                } else {
                    return res;
                }
            }))
            .pipe(
                retry(0),
                catchError(this.handleError.bind(this, url))
            );
    }

    post(url, body, options, custom = false) {

        let postUrl = url;
        let urlEncode = false;
        url = this.appendUserInfo(url).url;
        if (options == null) {
            options =
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
                withCredentials:true ////cdn防御
            };
            urlEncode = true;
        }

        if (urlEncode && typeof (body) != 'string') {
            body = HttpClientHelper.JSONtoQueryString(body);
        }

        body = this.uriSignature("?" + body, true);

        return this._httpClient.post(url, body, options)
            .pipe(map((res: any) => {
                if (this.unhandledApis.indexOf(postUrl) >= 0) {
                    return typeof (res) == 'string' ? JSON.parse(res) : res;//JSON.parse(JSON.stringify(res));
                }

                if (!custom) {
                    const r = typeof (res) == 'string' ? JSON.parse(res).data : res['data'];

                    if (!this.globalHandler(r)) {
                        return { code: 400 + r.code, msg: r.msg };
                    }

                    if (!r) {
                        console.log('API错误：API没有包含INFO字段', url);
                    }
                    return r.info;
                } else {
                    return res;
                }

            }))
            .pipe(
                retry(0),
                catchError(this.handleError.bind(this, url))
            );
    }

    private isHandlingUnkwon = false;
    private handleError(url: string, error: HttpErrorResponse) {
        //console.log("some error",url)
        if (null != error
            && error.status == 0
            && !this.isHandlingUnkwon
            && !!url
            && url.indexOf("play") > -1
        ) {
            this.isHandlingUnkwon = true;
            let nextUrl =this._utility.getLocation().href.replace(/[\?\&]?clearCache\=.*$/, "").replace("&clearCache", "");
            if (confirm("发生未知错误，确认后将自动刷新页面，如果多次无法解决，请联系客服")) {
                this._utility.getLocation().href = nextUrl +
                    (nextUrl.indexOf("?") > -1 ? "&" : "?") + "clearCache=" + Math.random();
            }

        }

        return EMPTY;
        // if (error.error instanceof ErrorEvent) {
        //     //  console.error('An error occurred:', error.error.message);
        // } else {

        // }
        // return ErrorObservable.create(error);
    }
}
